import React from 'react';
import removeMarkdown from 'remove-markdown';
import { RichTextEditor } from '@/components/design-system/molecules/rich-text-editor';
import { ColocIcon } from '@/components/design-system/atoms/icon';

interface MessageInputProps {
  message: string;
  characterLimit?: number;
  onChange: (value: string) => void;
  id?: string;
  label: string;
  required?: boolean;
}

const getMarkdownTextLength = (markdown: string): number =>
  removeMarkdown(markdown).trim().length;

export const MessageInput = ({
  message,
  characterLimit,
  onChange,
  label,
  id = 'message',
  required = false,
}: MessageInputProps): JSX.Element => {
  const messageId = `message-input-${id}`;
  const textLength = getMarkdownTextLength(message);
  const isOverLimit = characterLimit !== undefined && textLength >= characterLimit;

  return (
    <div className="flex flex-col gap-2">
      <RichTextEditor
        id={messageId}
        label={label}
        required={required}
        value={message}
        onChange={onChange}
      />
      {characterLimit !== undefined && (
        <div className="flex justify-end">
          <span
            className={`text-footnote1 ${isOverLimit ? 'text-text-failed' : 'text-text-tertiary'}`}
          >
            {textLength}/{characterLimit}
          </span>
        </div>
      )}
      {isOverLimit && (
        <div className="flex flex-row items-start gap-2 rounded-[8px] border border-solid border-border-primaryLight bg-bg-primaryMedium p-[12px]">
          <ColocIcon name="information" className="text-text-secondary" size={18} />
          <span className="flex-grow text-body text-text-primaryHeavy">
            You have exceeded the default character limit for the description, so your broadcast
            message will be converted into an announcement message.
          </span>
        </div>
      )}
    </div>
  );
};
